const initState = {
	appUserId: localStorage.getItem("APP_USER_ID"),
	locations: [],
	location: [],
	zodiacSystem: [],
	activity: [],
	courier: [],
	screenNotification: [],
	emailTemplate: [],
	administrationlist: [],
	rolesList: [],
};

const main = (state = initState, action) => {
	switch (action.type) {
		case "ORGANIZATION":
			return {
				...state,
				organization: action.payload,
			};
		case "LOCATION":
			return {
				...state,
				location: action.payload,
			};
		case "LOCATION_LIST":
			return {
				...state,
				locations: action.payload,
			};
		case "ZODIAC_SYSTEM":
			return {
				...state,
				zodiacSystem: action.payload,
			};
		case "ACTIVITY_LIST":
			return {
				...state,
				activity: action.payload,
			};
		case "GUEST_ACTIVITY_LIST":
			return {
				...state,
				guestActivity: action.payload,
			};
		case "COURIER_LIST":
			return {
				...state,
				courier: action.payload,
			};
		case "CHANGE_SCREEN_NOTIFICATION":
			return {
				...state,
				screenNotification: action.payload,
			};
		case "CHANGE_EMAIL_TEMPLATE":
			return {
				...state,
				emailTemplate: action.payload,
			};
		case "CHANGE_ADMIN_LIST":
			return {
				...state,
				administrationlist: action.payload,
			};
		case "CHANGE_ROLE_LIST":
			return {
				...state,
				rolesList: action.payload,
			};
		default:
			return state;
	}
};

export default main;
